import AuditTrail from "../audit.trail";

export const ItemMenuLog = (WrappedComponent) => (props) => {
  const { event, eventParams, ...otherProps } = props;

  const onLog = (event, action, eventParams) => {
      if (event && action) {
          AuditTrail.sendLog(event, Object.assign({tag: 'item-menu', event: action, label: props.label? props.label : ''}, eventParams));
      }
  }

  return (
    <WrappedComponent
        {...otherProps}
        onOpen={(context) => {
            onLog(event, 'onOpen', eventParams);
            if (props.onOpen) {
                props.onOpen(context);
            }
        }}
        onClose={(context) => {
            onLog(event, 'onClose', eventParams);
            if (props.onClose) {
                props.onClose(context);
            }
        }}
    />
  );
};
